import { render, staticRenderFns } from "./DeveloperAuthenticator.vue?vue&type=template&id=86b0b83c&scoped=true&"
import script from "./DeveloperAuthenticator.vue?vue&type=script&lang=ts&"
export * from "./DeveloperAuthenticator.vue?vue&type=script&lang=ts&"
import style0 from "./DeveloperAuthenticator.vue?vue&type=style&index=0&id=86b0b83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b0b83c",
  null
  
)

export default component.exports